import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledDiv = styled.div`
  & + & {
    margin-top: 18px;
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  background-color: ${({ active }) => (active ? colours.Shades.BlueShade20 : colours.Greyscale.White)};
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: ${colours.Shades.BlueShade20};
    cursor: pointer;
  }
`;

export const StyledInput = styled.input`
  display: none;

  &:checked + ${StyledLabel} {
    background-color: ${colours.Shades.BlueShade20};
  }

  &:disabled + ${StyledLabel} {
    cursor: not-allowed;
    background: ${colours.Greyscale.MistGrey};
  }
`;
